import { Injectable } from '@angular/core';
import { SchedulingCampaignsService } from './campaigns-service/campaigns.service';
import { SchedulingEventsService } from './events-service/events.service';

@Injectable()
export class SchedulingApiService {

  constructor(
      public events: SchedulingEventsService,
      public campaigns: SchedulingCampaignsService,
    ) { }

}
